
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.977.641c.072 0 .143.019.205.054l8.981 5.042a.619.619 0 01.063 1.05l-.063.04-8.27 4.653.042 4.26a.63.63 0 01-.56.625l-.084.005a.639.639 0 01-.647-.626L.576 1.034a.397.397 0 01.4-.393z","fill-rule":"evenodd"}})])
          )
        }
      }
    